import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const PrimarySchool = () => {
     useEffect(() => {
        document.title = 'Primary School -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li>  
     <li>Primary School </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Primary School  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <h3> Preparatory Stage (Class III - V) </h3>
       <p>In the Preparatory Stage, the focus shifts to building cognitive abilities and conceptual understanding. We emphasize interactive learning, where students move from learning basic concepts to critical thinking and independent learning. Through hands-on activities, experiments, and project-based learning, students gain a deeper understanding of subjects such as mathematics, science, social studies, and languages. </p>
       
             <p><b>Key Areas of Focus:</b></p>
                <ul className="list">
               <li> <b> Interdisciplinary learning: </b> Encouraging the integration of knowledge across subjects, such as connecting science and social studies to real-world issues.
               </li>
               <li> <b> Active learning: </b> Group discussions, debates, role plays, and educational games to enhance participation and teamwork.
               </li>
               <li> <b> Foundational knowledge: </b> Strong focus on reading comprehension, mathematical problem-solving, and scientific inquiry.
               </li>
               <li> <b> Social responsibility: </b> Introducing social outreach programs, where students actively participate in initiatives that foster empathy, teamwork, and community engagement.
               </li>
               <li> <b> Club initiatives: </b> Clubs like Environment Club, Debate Club, and Literary Club encourage students to explore interests outside of the classroom.
               </li>
               <li> <b> Sports: </b> Introducing structured team sports, such as football, cricket, and basketball, to develop physical fitness, strategy, and teamwork.
               </li>
               <li> <b> Art-integrated learning: </b> Students use artistic methods to explore concepts in subjects like history, science, and mathematics.</li>
       </ul>
           <p><b> Learning Outcomes:</b></p>
                <ul className="list">
               <li> <b> Academic Skills:</b> Improved understanding of core subjects with an emphasis on critical thinking and problem-solving.
               </li>
               <li> <b> Physical Fitness:</b> Development of coordination, strategic thinking, and teamwork through involvement in team sports.
               </li>
               <li> <b> Social Skills:</b> Stronger sense of social responsibility and teamwork, developed through outreach and club participation.
               </li>
               <li> <b> Creativity:</b> Enhanced creative skills through art-integrated learning experiences.</li>
           </ul>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default PrimarySchool
